import { render, staticRenderFns } from "./MealPreference.vue?vue&type=template&id=a0a4ccb2&"
import script from "./MealPreference.vue?vue&type=script&lang=js&"
export * from "./MealPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports